import isSuggestedRepliesEnabled from '../../selectors/isSuggestedRepliesEnabled';
import OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import { getUserConfiguration } from 'owa-session-store';
import { mutator } from 'satcheljs';
import { updateAction } from '../actions/suggestedRepliesOptionActions';

export default mutator(updateAction, () => {
    const userConfiguration: OwaUserConfiguration = getUserConfiguration();
    const userOptions: UserOptionsType = userConfiguration && userConfiguration.UserOptions;

    // If user options not available, no need to process further.
    if (!userOptions) {
        return;
    }

    // Update the value of the local userOptions store object, which represents the backend state.
    const suggestedRepliesEnabled: boolean = isSuggestedRepliesEnabled();
    userOptions.WebSuggestedRepliesEnabledForUser = suggestedRepliesEnabled;
});
